import {
    debug
} from '@kkmh/utils'

export const doTrackPv = (opt = {}) => {
    if (checkIdentify()) {
        let activity_name = 'ReadCheckout';
        let param = {
            CurPage : opt.trigger_page || '',
        };
        debug(activity_name, param);
        kksa.track(activity_name, param);
    }
}

export const doTrackClick = (btnname, opt={}) => {
    if (checkIdentify()) {
        let activity_name = 'PayActivityBtnClk';
        let param = {
            PayActivityName     : opt.third_activity,
            PayActivitySubName  : opt.trigger_page,
            TriggerPage         : opt.origin,
            ButtonName          : btnname,
        };
        debug(activity_name, param);
        kksa.track(activity_name, param);
    }
}

function checkIdentify() {
    // return true;
    if (typeof kksa != "undefined" && kksa.is_track_identify) {
        return true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/kkbhalfscreen/js/track.js